<template>
    <div class="col-12">
        <div class="row justify-content-center">
            <b-overlay :show="loading" class="content">
                <div class="mb-3 text-center">
                    <hr />
                    <strong> ثبت محصول جدید در فروشگاه {{ shopName }}</strong>
                    <hr />
                </div>
                <div class="col-12 col-md-6 p-0 offset-md-3 float-left">
                    <button type="button" @click="$router.back()" class="btn btn-info">بازگشت</button>
                </div>
                <form @submit="onSubmit"
                      id="ProductForm"
                      class="col-12 col-md-6 offset-md-3 float-left mt-4 pt-4 pb-4 bg-white">
                    <b-progress :value="(step - 1) * (100/7)" class="mb-3"></b-progress>
                    <div v-if="step==1">
                        <div class="alert alert-light text-center">
                            <h6>نام محصول را وارد نمایید</h6>
                        </div>
                        <b-form-group :label="$t('param.product.name')">
                            <b-form-input type="text"
                                          id="name"
                                          :data-label="$t('param.product.name')"
                                          class="form-control"
                                          autocomplete="off"
                                          v-model="name"
                                          data-validations='["required"]'></b-form-input>
                        </b-form-group>
                    </div>
                    <div v-if="step==2">
                        <div class="alert alert-light text-center">
                            <h6>کازمزد ماهیانه محصول را وارد نمایید، در صورتی که محصول بدون کامزد است 0 وارد نمایید</h6>
                        </div>
                        <b-form-group :label="$t('param.product.wagePercent')">
                            <b-form-input type="number"
                                          id="price"
                                          step="0.01"
                                          :data-label="$t('param.product.wagePercent')"
                                          class="form-control"
                                          autocomplete="off"
                                          v-model="wagePercent"
                                          data-validations='["required"]'></b-form-input>
                        </b-form-group>
                    </div>
                    <div v-if="step==3">
                        <div class="alert alert-light text-center">
                            <h6>قیمت محصول را به ریال وارد نمایید</h6>
                        </div>
                        <b-form-group :label="$t('param.product.price')">
                            <b-form-input type="number"
                                          id="price"
                                          :data-label="$t('param.product.price')"
                                          class="form-control"
                                          autocomplete="off"
                                          v-model="price"
                                          data-validations='["required"]'></b-form-input>
                        </b-form-group>
                    </div>
                    <div v-if="step==4">
                        <div class="alert alert-light text-center">
                            <h6>تعداد موجودی محصول را وارد نمایید</h6>
                        </div>
                        <b-form-group :label="$t('param.product.count')">
                            <b-form-input type="number"
                                          id="price"
                                          :data-label="$t('param.product.count')"
                                          class="form-control"
                                          autocomplete="off"
                                          v-model="count"
                                          data-validations='["required"]'></b-form-input>
                        </b-form-group>
                    </div>
                    <div v-if="step==5">
                        <div class="alert alert-light text-center">
                            <h6>در این قسمت توضیحاتی در رابطه با محصول وارد نمایید</h6>
                        </div>
                        <b-form-group :label="$t('param.product.description')">
                            <b-form-textarea type="number"
                                             id="description"
                                             :data-label="$t('param.product.description')"
                                             class="form-control"
                                             autocomplete="off"
                                             rows="5"
                                             v-model="description"
                                             data-validations='["required"]'></b-form-textarea>
                        </b-form-group>
                    </div>
                    <div v-if="step==6">
                        <div class="alert alert-light text-center">
                            <h6>یک تصویر برای برای محصول خود انتخاب کنید</h6>
                        </div>
                        <div class="text-center">
                            <img v-if="imageUrl" :src="imageUrl" class="mt-2 mb-2" style="max-width: 250px; margin: 0 auto;" />
                        </div>
                        <div class="custom-file">
                            <input type="file" accept=".jpg,.png" @change="previewFile" class="custom-file-input" id="imageFile">
                            <label class="custom-file-label" for="imageFile"></label>
                        </div>
                    </div>
                    <div v-if="step==7">
                        <div class="alert alert-light text-center">
                            <h6>در صورتی که از اطلاعات وارد شده اطمینان دارید بر روی دکمه "مرحله بعد" کلیک نمایید</h6>
                        </div>
                        <table class="table table-striped">
                            <tr>
                                <th>نام محصول</th>
                                <td>{{ name }}</td>
                            </tr>
                            <tr>
                                <th>کارمزد ماهیانه</th>
                                <td>{{ wagePercent }}</td>
                            </tr>
                            <tr>
                                <th>قیمت</th>
                                <td>{{ price }}</td>
                            </tr>
                            <tr>
                                <th>توضیحات</th>
                                <td>{{ description }}</td>
                            </tr>
                            <tr>
                                <th>تصویر</th>
                                <td>
                                    <div class="text-center">
                                        <img v-if="imageUrl" :src="imageUrl" class="mt-2" style="max-width: 200px; margin: 0 auto;" />
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <p class="alert alert-warning flo mt-2 errors" v-if="warnings.length">
                        <label></label>
                        <ul>
                            <li v-for="warning in warnings">
                                {{ $t(warning.type,{label:warning.label}) }}
                            </li>
                        </ul>
                    </p>
                    <p class="alert alert-danger mt-2 errors" v-if="errors.length">
                        <label></label>
                        <ul>
                            <li v-for="error in errors">
                                {{ $t(error.type) }}
                            </li>
                        </ul>
                    </p>
                    <div v-if="step == 1" class="col-12 mt-2 pr-0 pl-0 float-right">
                        <button class="btn btn-block btn-dark mt-2" type="submit" v-bind:disabled="loading">
                            <span v-if="!loading">مرحله بعد</span>
                            <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                        </button>
                    </div>
                    <div v-if="step > 1" class="col-12 pr-0 pl-0 mt-2 float-right">
                        <div class="col-2 pr-0 pl-1 float-right">
                            <button class="btn btn-outline-dark btn-block mt-2" type="button" @click="onPrev">
                                <b-icon icon="arrow-right-short"></b-icon>
                            </button>
                        </div>
                        <div class="col-10 pr-1 pl-0 float-right">
                            <button class="btn btn-block btn-dark mt-2" type="submit" v-bind:disabled="loading">
                                <span v-if="!loading">مرحله بعد</span>
                                <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                            </button>
                        </div>
                    </div>
                </form>
            </b-overlay>
        </div>
    </div>
</template>
<script>
    import store from "@/store";
    import utility from '@/plugins/utility';
    import Compressor from 'compressorjs';

    export default {
        data()
        {
            return {
                step: 1,
                indexKey: 0,
                loading: false,
                warnings: [],
                errors: [],
                shopName: null,
                shopId: null,
                image: null,
                imageUrl: null,
                productId: null,
                productCategories: [],
                wagePercent: 0,
                productCategoryName: '',
                productLevel: 0,
                name: '',
                caption: '',
                description: '',
                price: '',
                count: ''
            }
        },

        beforeMount()
        {
            if (store.selectedProduct != null)
            {
                this.wagePercent = store.selectedProduct.wagePercent;
                this.name = store.selectedProduct.name;
                this.description = store.selectedProduct.description;
                this.price = store.selectedProduct.price;
                this.count = store.selectedProduct.count;
                this.shopName = store.selectedProduct.shopName;
                this.shopId = store.selectedProduct.shopId;
                this.productId = store.selectedProduct.productId;
                this.imageUrl = store.selectedProduct.imagePath;

                return;
            }


            if (store.selectedShop != null)
            {
                this.shopName = store.selectedShop.name;
                this.shopId = store.selectedShop.shopId;

                return;
            }

            this.$router.push({ name: 'club', params: { action: 'shop' } });
        },


        methods: {

            //initProductCategories()
            //{
            //    axios({ method: "get", url: "/api/General/GetAllProductCategories" })
            //        .then(response =>
            //        {
            //            for (var i = 0; i < response.data.productCategories.length; i++)
            //            {
            //                this.productCategories.push({
            //                    text: response.data.productCategories[i].name,
            //                    value: response.data.productCategories[i].productCategoryId.toString()
            //                })
            //            }

            //            this.loading = false;
            //        })
            //        .catch(error => { });
            //},

            previewFile(event)
            {
                var self = this;
                this.loading = true;
                var reader = new FileReader();
                reader.addEventListener("load", function ()
                {
                    self.imageUrl = reader.result;
                    self.loading = false;

                }, false);

                if (event.target.files.length > 0)
                {
                    this.image = event.target.files[0]
                    reader.readAsDataURL(event.target.files[0]);
                }
            },


            onSubmit(evt)
            {
                var form = new utility.form('#ProductForm');
                evt.preventDefault()
                this.warnings = form.errors();
                this.errors = [];

                var self = this;

                if (this.warnings.length == 0)
                {

                    if (this.step == 7)
                    {
                        self.loading = true;

                        if (self.image == null)
                        {
                            self.save()
                            return;
                        }

                        new Compressor(self.image, {
                            quality: 0.8,
                            maxWidth: 500,
                            success(result)
                            {
                                var reader = new FileReader();
                                reader.addEventListener("load", function ()
                                {
                                    self.compressedImage = reader.result
                                    self.save()

                                }, false);

                                reader.readAsDataURL(result);
                            }
                        });
                    }
                    else this.step += 1;
                }
            },


            save()
            {
                var self = this;
                var data = {
                    ProductID: this.productId,
                    ShopID: this.shopId,
                    Image: this.compressedImage,
                    WagePercent: this.wagePercent,
                    ProductLevel: 1,
                    Name: this.name,
                    Description: this.description,
                    Price: this.price,
                    Count: this.count
                }


                axios({ method: "post", url: "/api/app/SaveProduct", data: data })
                    .then(response =>
                    {
                        self.loading = false;

                        if (response.data.success)
                        {
                            self.$bvToast.toast('محصول شما با موفقیت ثبت شد و بعد از تایید در سایت نمایش داده میشود', {
                                title: 'عملیات موفق',
                                toaster: 'b-toaster-top-center',
                                variant: 'success',
                                bodyClass: 'text-center',
                                noCloseButton: true,
                                solid: true
                            })

                            self.resetForm()

                            return;
                        }

                        self.$bvToast.toast('خطا در ثبت محصول، لطفا با پشتیانی سیستم تماس بگیرید.', {
                            title: 'عملیات ناموفق',
                            toaster: 'b-toaster-top-center',
                            variant: 'danger',
                            bodyClass: 'text-center',
                            noCloseButton: true,
                            solid: true
                        })
                    })
                    .catch(error => { });
            },

            request(url, data, succees, method)
            {
                this.loading = true;
                axios({
                    method: method || 'post',
                    url: url,
                    data: data
                })
                    .then(response =>
                    {
                        this.loading = false;
                        succees(response.data)
                    })
                    .catch(error =>
                    {
                        this.errors = [{ type: 'errors.server' }];
                        this.loading = false;
                    });
            },

            resetForm()
            {
                this.step = 1;
                this.loading = false;
                this.warnings = [];
                this.errors = [];
                this.image = null;
                this.imageUrl = null;
                this.productId = null;
                this.wagePercent = '';
                this.productCategoryName = '';
                this.productLevel = 0;
                this.name = '';
                this.count = '';
                this.caption = '';
                this.description = '';
                this.price = '';
                this.indexKey += 1;
            },


            onPrev()
            {
                if (this.step > 1)
                {
                    this.errors = []
                    this.step -= 1
                }
            }
        }
    };
</script>
<style scoped>
    .custom-file-label {
        text-align: left;
    }

    .img {
        max-width: 250px;
        margin: 0 auto;
    }
</style>